
import React from "react";
import { Button } from "../ui/button";

interface SuccessMessageProps {
  name: string;
  selectedEatery: string;
  isEateryRequest: boolean;
  handleClose: () => void;
}

export function SuccessMessage({
  name,
  selectedEatery,
  isEateryRequest,
  handleClose
}: SuccessMessageProps) {
  return (
    <div className="py-6 text-center space-y-4">
      {isEateryRequest ? (
        <>
          <div className="text-xl font-bold text-gray-900">
            Thanks for your request <span className="font-bold text-eatsboost-orange">{name}</span>!
          </div>
          <p className="text-gray-700">
            Our <span className="font-bold">team</span> has received your request to add{" "}
            <span className="font-bold">{selectedEatery}</span> and will notify you once they join EatsBoost.
          </p>
        </>
      ) : (
        <>
          <div className="text-xl font-bold text-gray-900">
            Thanks, <span className="font-bold text-eatsboost-orange">{name}</span>!
          </div>
          <p className="text-gray-700">
            Our <span className="font-bold">sales team</span> will be in touch shortly to finalize your{" "}
            <span className="font-bold">Boost Card</span> purchase for{" "}
            <span className="font-bold">{selectedEatery}</span>.
          </p>
        </>
      )}
      <Button onClick={handleClose} className="mt-4 bg-eatsboost-orange hover:bg-eatsboost-orange/90 text-white">
        Close
      </Button>
    </div>
  );
}
